<style scoped lang="scss">
    .document-attachment {
        align-items: center;
        margin-bottom: 12px;
        border: thin solid #bbb;
        padding: 5px;
    }

    .document-note {
        font-size: 0.9em;
        color: #666;
    }
</style>

<template>
    <div class="uk-grid">
        <div class="uk-width-1-1">
            <div class="uk-grid uk-margin-top">
                <div class="uk-width-1-1 uk-text-center uk-margin-bottom uk-margin-top">
                    <button v-if="showCancel"  class="uk-button uk-button-default" @click="onCancel">
                        Cancel
                    </button>
                    <button  class="uk-button uk-button-primary" @click="saveAndPrint()">
                        {{ actionButtonLabel }}
                    </button>
                </div>
                <div v-if="docType === 'no-income'">
                    <vue-html2pdf
                        class="uk-width-1-1"
                        v-show="false"
                        :show-layout="true"
                        :float-layout="false"
                        :enable-download="false"
                        :preview-modal="false"
                        :paginate-elements-by-height="1400"
                        filename="rent"
                        :pdf-quality="2"
                        :manual-pagination="true"
                        :html-to-pdf-options="html2pdfOptions"
                        :pdf-content-width="400"
                        @beforeDownload="hasDownloaded($event)"
                        ref="noIncomeRef"
                    >
                        <section slot="pdf-content">
                            <NoIncomeAttestation
                                :member="member"
                                :incomes="incomes"
                                :additionalInfo="additionalInfo"
                            />
                            </NoIncomeAttestation>
                        </section>
                    </vue-html2pdf>
                </div>

                <div v-if="docType === 'no-income-hh'">
                    <vue-html2pdf
                        class="uk-width-1-1"
                        v-show="false"
                        :show-layout="true"
                        :float-layout="false"
                        :enable-download="false"
                        :preview-modal="false"
                        :paginate-elements-by-height="1400"
                        filename="rent"
                        :pdf-quality="2"
                        :manual-pagination="true"
                        :html-to-pdf-options="html2pdfOptions"
                        :pdf-content-width="400"
                        @beforeDownload="hasDownloaded($event)"
                        ref="noIncomeHHRef"
                    >
                        <section slot="pdf-content">
                            <NoIncomeHHAttestation
                                :member="member"
                            />
                            </NoIncomeHHAttestation>
                        </section>
                    </vue-html2pdf>
                </div>

                <div v-if="docType === 'no-income-entire-hh'">
                    <vue-html2pdf
                        class="uk-width-1-1"
                        v-show="false"
                        :show-layout="true"
                        :float-layout="false"
                        :enable-download="false"
                        :preview-modal="false"
                        :paginate-elements-by-height="1400"
                        filename="rent"
                        :pdf-quality="2"
                        :manual-pagination="true"
                        :html-to-pdf-options="html2pdfOptions"
                        :pdf-content-width="400"
                        @beforeDownload="hasDownloaded($event)"
                        ref="noIncomeEntireHHRef"
                    >
                        <section slot="pdf-content">
                            <NoIncomeEntireHHAttestation
                                :member="member"
                                :incomes="incomes"
                            />
                            </NoIncomeEntireHHAttestation>
                        </section>
                    </vue-html2pdf>
                </div>
            </div>
        </div>
        <preview-documents-modal ref="previewModal" @confirm="$refs.previewModal.close()"></preview-documents-modal>

    </div>
</template>

<script>
    import VueHtml2pdf from 'vue-html2pdf';
    import { mapState, mapGetters } from 'vuex';
    import { PDFDocument, StandardFonts, rgb } from 'pdf-lib';
    import NoIncomeAttestation from "./Attestations/NoIncomeAttestation";
    import NoIncomeHHAttestation from "./Attestations/NoIncomeHHAttestation";
    import NoIncomeEntireHHAttestation from "./Attestations/NoIncomeEntireHHAttestation";
    import PreviewDocumentsModal from "../../../../../../../dashboard/pages/Documents/PreviewDocumentModal";
    const download = require('downloadjs')

    export default {
        name: "DocRequest",
        components: {
            PreviewDocumentsModal,
            NoIncomeAttestation,
            NoIncomeHHAttestation,
            VueHtml2pdf,
            NoIncomeEntireHHAttestation
        },
        props: {
            applicationId: {
                type: Number,
                required: true,
            },
            docType: {
                type: String,
                required: true,
            },
            member: {
                type: Object,
                default: {},
            },
            income: {
                type: Object,
                default: {},
            },
            incomes: {
                type: Array,
                default: [],
            },
            additionalInfo: {
                type: Object,
                default: {},
            },
            showCancel: {
                type: Boolean,
                default: false,
            }
        },
        data() {
            return {
                checkedRentDocuments: [],
                checkedMortgageDocuments: [],
                checkedUtilityDocuments: [],
                purchaseAgreements: [],
                settings: {},
                loading: false,
                html2pdfOptions: {
                    margin: 5,
                    html2canvas: {
                        scale: 4,
                    },
                },
                jsPDF: {
                    format: 'letter',
                },
            }
        },
        computed: {
            actionButtonLabel() {
                let result = ''
                switch (this.docType) {
                    case 'no-income':
                        if (this.programSettings['uses-esign'])
                        {
                            result = 'Submit Form'
                        } else {
                            result = 'Download Attestation Document'
                        }
                        break;
                    case 'no-income-hh':
                        result = 'Download Attestation Document'
                        break;
                    case 'no-income-entire-hh':
                    default:
                        result = 'Download Attestation Document'
                        break;
                }
                return result
            },
            filenamePrefix() {
                let result = `${this.applicant.first_name.toLowerCase()}-${this.applicant.last_name.toLowerCase()}-application-${this.application.id}-income-attestation`;
                return result.replace('\'', '')
            },
            ...mapState('Application', {
                application: 'application',
                applicant: 'applicant',
                hhMembers: 'hhMembers',
                documentRequests: 'documentRequests',
                documents: 'documents',
                renterManager: 'renterManager',
                renterOwner: 'renterOwner',
                landlordConfirmations: 'landlordConfirmations',
            }),
            ...mapState('App', {
                env: state => state.env,
            }),
            ...mapGetters('Application', [ 'programSettings' ]),
        },
        watch: {
        },
        mounted() {
        },
        methods: {
            onCancel() {
                this.$emit('onCancel');
            },

            async saveAndPrint() {
                let ref = undefined
                switch (this.docType) {
                    case "no-income":
                        ref = "noIncomeRef"
                        break;
                    case "no-income-hh":
                        ref = "noIncomeHHRef"
                        break;
                    case "no-income-entire-hh":
                    default:
                        ref = "noIncomeEntireHHRef"
                        break;
                }
                this.$isLoading(true);
                // Scroll To Top.
                window.scrollTo(0,0);
                this.$forceUpdate();
                this.print(ref);
                this.$emit('onDownload');
            },

            print(ref) {
                if (ref && this.$refs[ref])
                    this.$refs[ref].generatePdf();
            },

            previewDocument(document) {
                let url =`/applicant/applications/${this.applicationId}/documents/${document.id}/preview`;
                this.$refs.previewModal.open(url, document);
            },

            async hasDownloaded({html2pdf, options, pdfContent}) {
                console.log(options);
                let pdf = await html2pdf().set(options).from(pdfContent).to('pdf').get('pdf');

                let output = await pdf.internal.output('arraybuffer');

                let pdfDoc = await PDFDocument.load(output);
                let pages = pdfDoc.getPages();
                // for(var i in pages) {
                //     pages[i].setSize(612, 792);
                // }


                let pdfData = await pdfDoc.save();
                download(pdfData, `${this.filenamePrefix}.pdf`, 'application/pdf');
                this.$isLoading(false);
            },
        },
    }
</script>
